import { render } from "./updateUser.vue?vue&type=template&id=64748ab3&scoped=true&ts=true"
import script from "./updateUser.vue?vue&type=script&lang=ts"
export * from "./updateUser.vue?vue&type=script&lang=ts"

import "./updateUser.vue?vue&type=style&index=0&id=64748ab3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64748ab3"]])

export default __exports__